import React from 'react'
import {
  getSidebarIconId,
  SIDEBAR_ICON_SPRITE_PATH,
  SidebarIconFilename,
} from '../../../app/components/sidebar/iconSprite.generated'

type Props = {
  className?: string
  icon: SidebarIconFilename
  svgClassName?: string
}

const KTSVGSprite: React.FC<Props> = ({className = '', icon, svgClassName = 'mh-50px'}) => {
  const href = SIDEBAR_ICON_SPRITE_PATH + '#' + getSidebarIconId(icon)

  return (
    <span className={'svg-icon ' + className}>
      <svg className={svgClassName} focusable='false' aria-hidden='true'>
        <use href={href} xlinkHref={href} />
      </svg>
    </span>
  )
}

export {KTSVGSprite}
